import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.571 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "28.571",
      height: "20",
      fill: "#0086e6",
      rx: "2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#eff8fe",
      d: "M17.8 5.147c-.546-.603-1.534-.861-2.798-.861h-3.667a.54.54 0 0 0-.34.121.5.5 0 0 0-.178.308L9.29 14.094a.308.308 0 0 0 .31.352h2.265l.568-3.493-.017.11a.52.52 0 0 1 .516-.43h1.076c2.114 0 3.769-.83 4.252-3.236q.022-.105.037-.208-.09-.046 0 0c.144-.889 0-1.494-.497-2.042"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M13.3 6.869a.5.5 0 0 1 .198-.043h2.875q.512 0 .948.066a4 4 0 0 1 .58.134q.213.07.397.163c.144-.89-.001-1.494-.498-2.042-.546-.603-1.534-.861-2.797-.861h-3.668a.52.52 0 0 0-.518.429L9.29 14.093a.308.308 0 0 0 .31.353h2.265l1.18-7.245a.456.456 0 0 1 .255-.332"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#a3d8ff",
      d: "M18.26 7.398c-.483 2.404-2.138 3.236-4.252 3.236h-1.076a.52.52 0 0 0-.516.429l-.708 4.343a.27.27 0 0 0 .272.308h1.909c.11 0 .215-.037.298-.106s.138-.164.155-.269l.019-.094.36-2.208.023-.122a.44.44 0 0 1 .155-.268.47.47 0 0 1 .298-.107h.286c1.848 0 3.296-.728 3.719-2.831.177-.88.085-1.614-.382-2.13a1.8 1.8 0 0 0-.522-.39z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "paypal-icon"}) } }